// material
import { Paper } from '@mui/material'
import { useState, useEffect } from 'react'
import axios from 'axios';
import settings from '../../config/settings';
import md5 from "md5";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import toast from 'react-hot-toast';
import { getUserInfo } from '../../config/services/users'

// ----------------------------------------------------------------------

var axiosInstance = axios.create()


export default function GetUserInfo({ userInfo }) {
  //console.log('User Info',userInfo)
  //const search = useLocation().search;
  //let UUID = new URLSearchParams(search).get('uuid'); 
  const [chartData, setChartData] = useState(null)
  const DATA_ACTION = "get_user_info_by_uuid"
  const LOGIN_ACTION = "cognito_login"
  const REFRESH_TOKEN_ACTION = "cognito_refresh_token"
  const API_KEY = "D21B2DBA59F52167BEBFF2484DAFB"
  //const CHECKSUM =  "e24ff4dd97b431813fe9d7b12d389860"   
  const WEBSITE_MSA_SALT = "CoLo&Mi!2021"
  //const REFRESH_TOKEN = "2bfd0fc4-d14d-4156-b784-9e1fc62ecaa6"
  //const REFRESH_TOKEN_TEST = "fb99fd8e-7845-46fc-9748-3b4a23eb5574"
  const DATA_URL = settings.WEBSITE_URL + 'getUserInfoByUuid'
  const LOGIN_URL = settings.WEBSITE_URL + 'login'
  const REFRESH_URL = settings.WEBSITE_URL + 'refreshToken'
  //const LOGIN_CHECKSUM = "97b237346453464fe0c7ad879fa2ae86"
  const USERNAME = "guestam"
  const PASSWORD = "Password@123"
  const ENV = settings.env
  const setHeader = (token) => ({
    headers: {
      'Authorization': 'Bearer ' + token,
      'token': token
    }
  })

  const getLoginCheckSum = (action, username, password) => {
    const loginParam = action + ":" + API_KEY + ":" + username + ":" + password + ":" + WEBSITE_MSA_SALT
    let checksum = md5(loginParam);
    return checksum
  }

  const WEBSITE_LOGIN_PAYLOAD = { "action": LOGIN_ACTION, "apikey": API_KEY, "checksum": getLoginCheckSum(LOGIN_ACTION, USERNAME, PASSWORD), "login_details": { "username": USERNAME, "password": PASSWORD, "app_name": "Student_App", "acess_id": "", "app_version": "", "gcm_key": "", "email_address": "", "latitude": "", "longitude": "", "operating_system_version": "", "source": "website" } }

  const REFRESH_TOKEN_PAYLOAD = {
    "action": REFRESH_TOKEN_ACTION,
    "apikey": API_KEY,
    "checksum": md5(REFRESH_TOKEN_ACTION + ':' + API_KEY + ':' + USERNAME + ':' + WEBSITE_MSA_SALT),
    "username": USERNAME,
    "refresh_token": settings?.WEBSITE_REFRESH_TOKEN
  }



  const DATA_REQUEST_PAYLOAD = {
    "action": DATA_ACTION,
    "apikey": API_KEY,
    "checksum": md5(DATA_ACTION + ':' + API_KEY + ':' + userInfo?.uuid + ':' + WEBSITE_MSA_SALT),
    "uuid": userInfo?.uuid
  }


  useEffect(() => {
    fetchUserData()
  }, [userInfo?.uuid])

  const fetchUserData = async () => {
    if (ENV === 'local') {
      try {
        let loginResponse = await axiosInstance.post(LOGIN_URL, WEBSITE_LOGIN_PAYLOAD)
        if (loginResponse?.status === 200) {
          const { access_token } = loginResponse?.data
          if (access_token) {
            axiosInstance.post(DATA_URL, DATA_REQUEST_PAYLOAD, setHeader(access_token))
              .then(async (response) => {
                if (response?.data?.status === 200) {
                  const data = response?.data?.data;
                  setChartData(data)
                }
              })
              .catch(async (error) => {
                if (error?.response?.status === 401) {
                  const refeshTokenResp = await axiosInstance.post(REFRESH_URL, REFRESH_TOKEN_PAYLOAD)
                  if (refeshTokenResp?.status === 200) {
                    const { access_token } = refeshTokenResp?.data
                    axiosInstance.post(DATA_URL, DATA_REQUEST_PAYLOAD, setHeader(access_token))
                      .then(resp => {
                        if (resp?.status === 200) {
                          const data = resp?.data?.data;
                          setChartData(data)
                        }
                      })
                      .catch(error => {
                        if (error?.reponse?.status === 401) {
                          toast.error(error?.reponse?.data?.errors[0]?.message)
                          return
                        }
                      })
                  }
                }
              })
          }
        }
      }
      catch (err) {
        if (err.response && err.response.data) {
          throw err.response.data
        }
        else {
          throw err
        }
      }
    }
    else {
      getUserInfo({ uuid: userInfo?.uuid })
        .then(response => {
          if (response?.data?.status === 200) {
            const data = response?.data?.data;
            if (data) {
              const { name, username, phoneNumber, email, address } = data;
              let filteredObj = {
                'Name': name, 'User Name': username, 'Mobile Number': phoneNumber, 'Email': email, 'Address': address
              }
              setChartData(filteredObj)
            }
          }
        })
        .catch((error) => {
          console.log("Data Error::", error?.response)
        })
    }
  }
  return (
    <TableContainer component={Paper} style={{
      maxWidth: '100%', margin: 'auto',
    }}>
      <Table style={{ maxWidth: '100%' }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {
              chartData && Object.keys(chartData).length && Object.keys(chartData).map(keys => (
                <TableCell key={keys} align="left">{keys}</TableCell>
              ))
            }
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow >
            {
              chartData && Object.values(chartData).length && Object.values(chartData).map(val => (
                <TableCell key={val} align="left">{val}</TableCell>
              ))
            }
          </TableRow>

        </TableBody>
      </Table>
    </TableContainer>
  )
}
